var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 216.1C70.1 216.1 67.4 213.5 67.4 210.3C67.4 209.4 67.7 208.5 68 207.8L91 162.1C91.8 160.5 93.4 159.2 95.1 159C97 158.7 98.7 159.3 100.1 160.6L123 183.5C124.3 184.8 124.9 186.6 124.6 188.5C124.3 190.3 123.1 191.9 121.5 192.6L75.8 215.5C74.9 215.8 74 216.1 73.2 216.1ZM97.6 174.4L86.2 197.7L109.5 186.3L97.6 174.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 193.3C117.4 193.3 115.9 192.7 114.9 191.7L92 168.7C89.7 166.4 89.7 162.8 92 160.6L179.6 73.2C187.4 65.8 199.5 65.8 207.3 73.2L210.6 76.5C218.2 84.1 218.2 96.5 210.6 104.2L123 191.5C121.9 192.7 120.4 193.3 118.9 193.3ZM104.1 164.6L118.9 179.4L202.3 96C205.4 92.9 205.4 87.7 202.3 84.6L198.9 81.3C195.8 78.2 190.6 78.2 187.5 81.3L104.1 164.6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3 118.9C191.8 118.9 190.3 118.3 189.3 117.3L157.4 85.4C155.1 83.1 151.5 83.1 149.3 85.4L123 111.6C120.7 113.9 117.1 113.9 114.9 111.6C112.6 109.3 112.6 105.7 114.9 103.5L141.2 77.3C148 70.8 158.7 70.8 165.5 77.3L197.4 109.2C199.7 111.5 199.7 115.1 197.4 117.3C196.3 118.3 194.8 118.9 193.3 118.9Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pen.f7ce7da8.svg";
export { ForwardRef as ReactComponent };